import { atom } from 'jotai'

const state = atom<boolean>(false)
export const commonContentPageLoadingStore = { state } as const
